import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    constructor() {}

    toasts: any[] = [];

    timeout: any;

    show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
        this.toasts = [];
        this.toasts.push({ textOrTpl, ...options });

        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
            this.clearAllToasts();
        }, 5000);
    }

    remove(toast: any) {
        this.toasts = this.toasts.filter((t) => t !== toast);
    }

    clearAllToasts() {
        this.toasts.forEach((element) => {
            this.remove(element);
        });
    }
}
